/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/** @jsx jsx */
import { jsx, Box, Container, Flex } from 'theme-ui';
import { merge } from 'lodash';
/* eslint-disable react/no-danger */
import React from 'react';

// Node Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Node Components
import ReactPlayer from 'react-player/wistia';
import Slider from 'react-slick';
import BackgroundImage from 'gatsby-background-image';
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';
// import Modal from 'react-modal';

// Types
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';
import { CTA } from '../../@types/cta';

// Components
import Text, { TEXT_TYPES } from '../../components/text';
import CTAButton from '../../components/ctaButton';
import IconColumn from '../../components/iconColumn';
import PlayerLightIcon from '../../components/playerLightIcon';
import TestimonialCard from '../../components/testimonialCard';

// Hooks
import useLinesBg from '../../hooks/useLinesBg';

// Icons
import ArrowLeftSVG from '../../../static/assets/icons/outlined/directions/chevron/left.svg';
import ArrowRightSVG from '../../../static/assets/icons/outlined/directions/chevron/right.svg';
// import CloseSVG from '../../../static/assets/icons/outlined/suggested/symbol/x.svg';

// Styles
import { baseStyle } from './style';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface AdvancedBenefitsProps extends Section {
  iconsRepeater: {
    title: string;
    content: string;
    icons: {
      title: string;
      paragraphText: string;
      numberTitle: string;
      subtextTitle: string;
      alternativeText: string;
      image: ImageType;
    }[];
  };
  videoArea: {
    title: string;
    url: string;
    image: ImageType;
    alternativeText: string;
  };
  logosCarousel: {
    title: string;
    time: number;
    logosRepeater: {
      alternativeText: string;
      image: ImageType;
    }[];
    cta: CTA;
  };
  testimonialCarousel: {
    time?: number;
    testimonialRepeater: {
      testimonialText: string;
      personText: string;
      positionText: string;
      image: ImageType;
      alternativeText: string;
    }[];
  };
}

const AdvancedBenefits: SectionComponent<any> = React.memo(
  ({
    iconsRepeater,
    videoArea,
    logosCarousel,
    testimonialCarousel,
  }: AdvancedBenefitsProps) => {
    // Refs
    const refPlayer = React.useRef();

    // Hooks
    const { fluid: fluidBg } = useLinesBg();

    // States

    // Handlers

    // Renders
    const CustomPrevArrow = React.useCallback(
      ({ className, onClick }: any) => (
        <div className={className} onClick={onClick}>
          <ArrowLeftSVG />
        </div>
      ),
      [],
    );

    const CustomNextArrow = React.useCallback(
      ({ className, onClick }: any) => (
        <div className={className} onClick={onClick}>
          <ArrowRightSVG />
        </div>
      ),
      [],
    );

    // Memos
    const logosList = React.useMemo(() => {
      if (logosCarousel && logosCarousel.logosRepeater) {
        if (logosCarousel.logosRepeater.length >= 5) {
          return [
            ...logosCarousel.logosRepeater,
            ...logosCarousel.logosRepeater,
          ];
        }
        return logosCarousel.logosRepeater;
      }
      return [];
    }, [logosCarousel]);

    return (
      <Box
        sx={{
          backgroundImage:
            'linear-gradient(to top, #3E3B7C 10%, #21244E 42.1%, #0B132B 90.47%)',
          '> div:before': { opacity: '0.45 !important' },
        }}
      >
        <BackgroundImage
          fluid={fluidBg}
          sx={{ backgroundColor: 'transparent', opacity: 0.4 }}
        >
          <Box>
            <Container sx={baseStyle.mainContainer}>
              {/* Part 1: Icons repeater  */}
              {(iconsRepeater?.content ||
                iconsRepeater?.icons ||
                iconsRepeater?.title) && (
                <Box sx={baseStyle.part1Container}>
                  {iconsRepeater?.title && (
                    <Text
                      lines="2"
                      sx={baseStyle.part1Title}
                      type={TEXT_TYPES.H2}
                    >
                      {iconsRepeater.title}
                    </Text>
                  )}

                  {iconsRepeater?.content && (
                    <Text
                      lines="2"
                      sx={baseStyle.part1Subtitle}
                      type={TEXT_TYPES.DISPLAY_SUBHEAD}
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: iconsRepeater.content,
                        }}
                      />
                    </Text>
                  )}

                  {iconsRepeater?.icons && (
                    <Flex sx={baseStyle.part1RepeaterContainer}>
                      {iconsRepeater.icons.map((iconItem, idx: number) => (
                        <IconColumn
                          key={idx}
                          image={iconItem.image}
                          title={iconItem.title}
                          paragraph={iconItem.paragraphText}
                          number={iconItem.numberTitle}
                          subtext={iconItem.subtextTitle}
                        />
                      ))}
                    </Flex>
                  )}
                </Box>
              )}

              {/* Part 2: Why kenna  */}
              {videoArea?.url && (
                <Box sx={baseStyle.part2Container}>
                  <Text
                    lines="2"
                    sx={baseStyle.part2Title}
                    type={TEXT_TYPES.H2}
                  >
                    {videoArea.title}
                  </Text>
                  <Box sx={baseStyle.part2VideoContainer}>
                    <ReactPlayer
                      ref={refPlayer}
                      url={videoArea.url}
                      width="100%"
                      height="100%"
                      light={
                        encodeURI(videoArea.image?.localFile?.publicURL) || true
                      }
                      controls
                      playIcon={<PlayerLightIcon />}
                      playing
                      // onClick={openModalPlayer}
                    />
                  </Box>
                  {/* Not needed now */}
                  {/* <Modal isOpen={modalPlayerOpen} onRequestClose={closeModalPlayer}>
                  <Flex sx={baseStyle.part2ModalHeader}>
                    <Button
                    type="button"
                      sx={baseStyle.part2ModalHeaderClose}
                      onClick={closeModalPlayer}
                      >
                      <img
                      src={CloseSVG}
                      alt="TODO:"
                      style={baseStyle.part2ModalHeaderCloseImg}
                      />
                      </Button>
                      </Flex>
                      <ReactPlayer
                      url="https://home.wistia.com/medias/e4a27b971d"
                      width="100%"
                    height="100%"
                    controls
                    playIcon={<PlayerLightIcon />}
                    config={{
                      options: {
                        autoPlay: true,
                      },
                    }}
                    />
                  </Modal> */}
                </Box>
              )}

              {/* Part 3: Logos carousel */}
              {logosList && (
                <Box
                  sx={
                    !testimonialCarousel?.testimonialRepeater
                      ? merge({}, baseStyle.part3Container, {
                        marginBottom: ['0', '0']
                      })
                      : baseStyle.part3Container
                  }
                >
                  <Text
                    lines="2"
                    sx={baseStyle.part3Title}
                    type={TEXT_TYPES.H2}
                  >
                    {logosCarousel.title}
                  </Text>
                  <Box
                    sx={
                      !logosCarousel?.cta?.url && !logosCarousel?.cta?.label
                        ? merge({}, baseStyle.part3SliderContainer, {
                          marginBottom: ['0', '0']
                        })
                        : baseStyle.part3SliderContainer
                    }
                  >
                    <Slider
                      className="slider"
                      dots={false}
                      draggable={false}
                      infinite
                      pauseOnHover
                      centerMode
                      slidesToShow={5}
                      slidesToScroll={5}
                      autoplay
                      autoplaySpeed={(logosCarousel.time || 2) * 1000}
                      nextArrow={<CustomNextArrow />}
                      prevArrow={<CustomPrevArrow />}
                      centerPadding="0"
                      responsive={[
                        {
                          breakpoint: 1360,
                          settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                          },
                        },
                      ]}
                    >
                      {logosList.map((logoItem: any, idx: number) => (
                        <Box key={idx} sx={baseStyle.part3SlideChild}>
                          <Flex sx={baseStyle.part3LogoContainer}>
                            <FluidImage
                              sx={baseStyle.part3Image}
                              {...logoItem.image}
                              altText={logoItem.alternativeText}
                            />
                          </Flex>
                        </Box>
                      ))}
                    </Slider>
                  </Box>
                  <CTAButton
                    type="link"
                    cta={logosCarousel.cta}
                    sx={baseStyle.part3cta}
                  >
                    {logosCarousel.cta?.label}
                  </CTAButton>
                </Box>
              )}
            </Container>

            {/* Part 4: Testimonial Carousel */}
            {testimonialCarousel?.testimonialRepeater && (
              <Box sx={baseStyle.part4Container}>
                <Slider
                  className="slider"
                  dots
                  infinite
                  variableWidth
                  centerMode
                  pauseOnHover
                  slidesToShow={1}
                  slidesToScroll={1}
                  adaptiveHeight
                  autoplay
                  autoplaySpeed={(testimonialCarousel.time || 2) * 1000}
                  responsive={[
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                      },
                    },
                  ]}
                >
                  {testimonialCarousel.testimonialRepeater.map(
                    (testimonialItem: any, idx: number) => (
                      <Box key={idx} sx={baseStyle.part4CardContainer}>
                        <TestimonialCard
                          quote={testimonialItem.testimonialText}
                          fullName={testimonialItem.personText}
                          position={testimonialItem.positionText}
                          image={testimonialItem.image}
                        />
                      </Box>
                    ),
                  )}
                </Slider>
              </Box>
            )}
          </Box>
        </BackgroundImage>
      </Box>
    );
  },
);

export default AdvancedBenefits;
